import React, { useState } from "react";
import { app } from "../../App";
import { StakeAction } from "../../eos/actions/StakeAction";
import { CustomAsset } from "../../hooks/useCards";
import { L } from "../../l10n/L10n";
import AssetImg from "./AssetImg";
import Styles from "./AssetView.module.scss";
import { GameButton, GameButtonStyleType } from "./GameButton";

type AssetViewUnstakedPropsType = {
	asset: CustomAsset
}

const AssetViewUnstaked = ({asset}: AssetViewUnstakedPropsType) => {
	const [btnReady, setBtnReady] = useState(true);

	function onStakeBtnClick()
	{
		setBtnReady(false);
		new StakeAction(asset.assetId, asset.templateId)
			.onSuccess(() => app.showInfo(L.common.success))
			.onError(() => setBtnReady(true))
			.executeAsync();
	}

	return (
		<div className={Styles.assetViewContainer}>
			<AssetImg img={asset.img} name={asset.name}/>
			<GameButton
				text={L.common.stake}
				onClick={onStakeBtnClick}
				style={GameButtonStyleType.SMALL}
				extraStyles={Styles.styleAssetButton}
				ready={btnReady}
			/>
		</div>
	);
};

export default AssetViewUnstaked;
